import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const PlayblastPauseNsk = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path d="M10.8 2.40002H3.60001V21.6H10.8V2.40002Z" fill={color} />
      <path d="M20.4 2.40002H13.2V21.6H20.4V2.40002Z" fill={color} />
      <path
        d="M4.80001 22.8H9.60001C10.2633 22.8 10.8 22.2633 10.8 21.6H3.60001C3.60001 22.2633 4.13671 22.8 4.80001 22.8Z"
        fill={color}
      />
      <path
        d="M13.2 21.6C13.2 22.2633 13.7367 22.8 14.4 22.8H19.2C19.8633 22.8 20.4 22.2633 20.4 21.6H13.2Z"
        fill={color}
      />
      <path
        d="M9.60001 1.19995H4.80001C4.13671 1.19995 3.60001 1.73665 3.60001 2.39995H10.8C10.8 1.73665 10.2633 1.19995 9.60001 1.19995Z"
        fill={color}
      />
      <path
        d="M19.2 1.19995H14.4C13.7367 1.19995 13.2 1.73665 13.2 2.39995H20.4C20.4 1.73665 19.8633 1.19995 19.2 1.19995Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

PlayblastPauseNsk.displayName = 'PlayblastPauseNsk';
